import { render, staticRenderFns } from "./IIN.vue?vue&type=template&id=4e5593e0"
import script from "./IIN.vue?vue&type=script&lang=js"
export * from "./IIN.vue?vue&type=script&lang=js"
import style0 from "./IIN.vue?vue&type=style&index=0&id=4e5593e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports